class AdditionalCosts {
    
    constructor(daysStay, depositPercentage, coronaInsurancePercentage = 3, translations) {
        $(function() {
            this.setUpEvents();
            var numPeople = parseInt($('#cvrm_booking_numPeople').val(), 10) || 0;
            $('.num-persons-based.mandatory input').each ( function ( index, element) {
                $(element).val(numPeople);
            });
            var bedlinenInput = document.querySelectorAll('[data-keyName="bedlinnen"] select');
            if (bedlinenInput.length > 0) {
                if (this.getCookie('bedlinen') == null) {
                    if (bedlinenInput[0].value == 0) {
                        bedlinenInput[0].value=numPeople;
                    }
                }
                if (this.getCookie('bedlinen') == 0) {
                    bedlinenInput[0].value = 0;
                }
            }
            this.calculateAll();
        }.bind(this));
        this.daysStay = daysStay;
        this.depositPercentage = depositPercentage;
        this.additionalCostsCalculators = []; 
        this.cancellationFundListener = null;
        this.coronaInsuranceListener = null;
        this.coronaInsurancePercentage = coronaInsurancePercentage;
        this.coverListener = null;
        this.formatter = new Intl.NumberFormat(this.getIntlLocale(document.documentElement.lang), {style: 'currency', currency: 'EUR', minimumFractionDigits: 2});
        this.checkSlashthrough();
        this.translations = translations;
    }
    
    calculateAll() {
        var numPeople = parseInt($('#cvrm_booking_numPeople').val(), 10) || 0;
        var youngsters = $('input:radio:checked#cvrm_booking_youngsters_1').val();
        var damageFund = $('tr[item-name="Damage Fund"]');
        if (damageFund.data('isIncluded') === false ) {
            if (youngsters == 1) {
                $('tr[item-name="Damage Fund"]').hide();
                $('tr[item-name="Damage Fund"] .quantity-col input').val(0);
            } else {
                $('tr[item-name="Damage Fund"]').show();
                $('tr[item-name="Damage Fund"] .quantity-col input').val(1);
            }
        }
        this.additionalCostsCalculators.forEach( (calculator) => {
            calculator(numPeople, this.daysStay);
        });

        var totalOnReservation = this.calculateOnReservation();
                
        if ($('#voucher').text().trim()){
            if ($('#voucher').data('type') === 'amount'){
                totalOnReservation -= parseInt($('#voucher').text());
                this.renderVoucher(parseInt($('#voucher').text()));
            } else {
                // get discount amount from voucher
                totalOnReservation -= $('#voucher-total').data('totalDiscount');
                this.renderVoucher($('#voucher-total').data('totalDiscount'));
            }            
        }
        var touristTax = 0;
        if (this.touristTaxCalculator) {
            var touristTaxPeople = parseInt($('#tourist-tax-select-numpeople').val(), 10) || 0;
            touristTax = this.touristTaxCalculator(touristTaxPeople, this.daysStay);
        }
        
        var cancellationFund = this.calculateCancellationFund(totalOnReservation);
        $('#cancellation-fund-total').text( this.formatter.format(cancellationFund));
        var coronaInsuranceAmount = this.calculateCoronaInsurance(totalOnReservation);
        $('#corona-insurance-total').text( this.formatter.format(coronaInsuranceAmount));
        // var coverAmount = this.calculateCover(parseFloat($('#rental-sum-total').text()));
        // $('#cover-total').text( this.formatter.format(coverAmount));
        var coverAmount = 0;
        var discount = $('#discount').text() || 0;
        totalOnReservation += touristTax - discount;
        this.calculateDepositAmount(totalOnReservation, cancellationFund, touristTax, coronaInsuranceAmount, coverAmount);
        this.calculateBalanceAmount(totalOnReservation, cancellationFund, touristTax, coronaInsuranceAmount, coverAmount);
        this.renderOnReservation(totalOnReservation+ cancellationFund + coronaInsuranceAmount + coverAmount);
        this.calculateOnArrival();
    }

    checkSlashthrough() {
        var el = document.getElementById('rental-sum-slashthrough');
        if (el ) {
            var slashthroughValue = el.getAttribute('data-value');
            var rentalSum = parseFloat(document.getElementById('rental-sum-total').innerText);
            if (slashthroughValue > rentalSum) {
                var currentRent = $('#rental-sum-total-displayable').html();
                $('#rental-sum-total-displayable').html('<div id="rental-sum-slashthrough-displayable" class="slashthrough text-right"> ' +   this.formatter.format(el.getAttribute('data-value')) + '</div>' + currentRent);
            }
        }
    }
    calculateDepositAmount(totalOnReservation, cancellationFund, touristTax, coronaInsurance, coverAmount)
    {
        if (this.depositPercentage > 0 ) {
            $('#total-deposit, #total-deposit-sidebar').text( this.formatter.format( (totalOnReservation - touristTax) * this.depositPercentage / 100 + cancellationFund + coronaInsurance + coverAmount));
        } else {
            $('#total-deposit, #total-deposit-sidebar').text( this.formatter.format(0.0));
        }
    }

    calculateBalanceAmount(totalOnReservation, cancellationFund, touristTax, coronaInsurance, coverAmount)
    {
        if (this.depositPercentage == 0) {
            totalOnReservation += parseFloat(cancellationFund) + parseFloat(coronaInsurance) + parseFloat(coverAmount);
        }
        $('#total-remaining-balance, #total-remaining-balance-sidebar ').text( this.formatter.format( (totalOnReservation - touristTax) - ((totalOnReservation - touristTax) * this.depositPercentage / 100) + touristTax));
    }

    calculateCancellationFund(amount) {
        if ($('#cvrm_booking_additionalCost_cancellationFundEnabled').is(':checked')) {
            this.renderCancellationFundPercentage(amount);
            return amount * 0.048;
        } else {
            this.renderCancellationFundPercentage(0);
            return 0;
        }
    }

    calculateCoronaInsurance(amount) {
        $('.corona-insurance-percentage').html(this.coronaInsurancePercentage);
        if ($('#cvrm_booking_additionalCost_cancellationFundEnabled').is(':checked') && $('#cvrm_booking_additionalCost_coronaInsuranceEnabled').is(':checked')) {
            $('#cvrm_booking_additionalCost_coronaInsurancePercentage').val(this.coronaInsurancePercentage);
            return amount * this.coronaInsurancePercentage/100;
        } else {
            $('#cvrm_booking_additionalCost_coronaInsurancePercentage').val(0);
            return 0;
        }
    }
    calculateCover(totalRentalSum) {
        var coverAmount = parseFloat(document.getElementById('cover-percentage').innerText) / 100 * totalRentalSum;
        return coverAmount;
    }
    calculateOnReservation() {
        var total = 0;
        if ($('#rental-sum-included-total').text() !== '') {
            total += parseFloat($('#rental-sum-included-total').text());
        } else {
            total += parseFloat($('#rental-sum-total').text());
        }
        $('.on-reservation .total-single-additional-cost:not(.included)').each(function(idx, el) {
            total += parseFloat($(el).text());
        });
        return total;
    }

    renderOnReservation(total) {
        $('#total-additional-reservation, #total-reservation-sidebar').text( this.formatter.format(total));
    }
    
    renderVoucher(total) {
        $('#voucher-display').text('-' +  this.formatter.format(total));
    }
    
    renderCancellationFundPercentage(amount) {
        $('.cc-percentage').html('4.80');
    }
    
    calculateOnArrival() {
        var total = 0;
        $('.on-arrival .total-single-additional-cost').each(function(idx, el) {
            total += parseFloat($(el).text());
        });
        $('#total-additional-arrival').text( this.formatter.format(total));

    }

    addCancellationFundListener(source, target) {
        $(source).on('change', function(e) {
            this.calculateAll();
        }.bind(this)) ;
    }
    addCoronaInsuranceListener(source, target) {
        $(source).on('change', function(e) {
            this.calculateAll();
        }.bind(this)) ;
    }
    addCoverListener(source, target) {
        $(source).on('change', function(e) {
            this.calculateAll();
        }.bind(this)) ;
    }
    setTouristTaxItemListener(source, target, targetDisplay, price) {
        this.touristTaxCalculator = function(numPeople, numDays) {
            price = parseFloat(price);
            var quantity = source.val();
            if (quantity == null || quantity == 'NaN') {
                quantity = 0;
            }
            quantity = parseInt(quantity, 10) || 0;
            var totalPrice = price;
            totalPrice = quantity * Math.min(7, numDays) * price;
            target.text(totalPrice);
            targetDisplay.text(this.formatter.format(totalPrice));
            return totalPrice;
        }.bind(this);
        $(source).on('change', function(e) {
            this.calculateAll();
        }.bind(this));
    }

    addItemListener(source, target, targetDisplay, price, type, mandatory, isIncluded, minQuantity, available) {
        this.additionalCostsCalculators.push( function(numPeople, numDays) {
            price = parseFloat(price);
            minQuantity = parseInt(minQuantity, 10) || 0;
            var quantity = (available == 'YES' && minQuantity > 0 && minQuantity > source.val()) ? minQuantity : source.val();
            if (quantity == null || quantity == 'NaN' || available == 'NO') {
                quantity = 0;
            }
            if (source.attr('type') == 'checkbox') {
                quantity = source.is(':checked') ? quantity : 0;
            }
            quantity = parseInt(quantity, 10);

            var totalPrice = price;
            switch (type) {
                case 'ONCE':
                    totalPrice = quantity * price;
                    break;
                case 'DAY':
                    totalPrice = quantity * numDays * price;
                    break;
                case 'PERSON/DAY':
                    if (mandatory) {
                        quantity = (minQuantity > 0) ? minQuantity : numPeople;
                    }
                    totalPrice = quantity * numDays * price;
                    break;
                case 'PERSON':
                    if (mandatory) {
                        quantity = (minQuantity > 0) ? minQuantity : numPeople;
                    }
                    totalPrice = quantity * price;
                    break;
                case 'TOURIST_TAX':
                    totalPrice = quantity * Math.min(7, numDays) * price;
                    break;
            }
            target.text(totalPrice);
            if(isIncluded === true) {
                targetDisplay.text(this.translations.messages.included);
            } else {
                targetDisplay.text( this.formatter.format(totalPrice));
            }
            return totalPrice;
        }.bind(this));
        $(source).on('change', function(e) {
            this.calculateAll();
        }.bind(this));
    }

    setUpEvents() {
        document.body.addEventListener('change', function (e) {
            if (e.target && e.target.id === 'cvrm_booking_numPeople') {
                var numPeople = document.querySelector('#cvrm_booking_numPeople').value;
                var inputs = document.querySelectorAll('.num-persons-based.mandatory input');
                for (var i = 0; i < inputs.length; i++) {
                    inputs[i].value = numPeople;
                }
                document.getElementById('number-of-people-sidebar').textContent = numPeople;
                if (!this.getCookie('bedlinen') || this.getCookie('bedlinen') > 0) {
                    var bedlinenInput = document.querySelectorAll('[data-keyName="bedlinnen"] select');
                    if (bedlinenInput.length > 0) {
                        bedlinenInput[0].value = numPeople;
                    }
                }
                this.calculateAll();
            }
        }.bind(this));

        document.body.addEventListener('change', function (e) {
            if (e.target && e.target.id === 'cvrm_booking_youngsters') {
                this.calculateAll();
            }
        }.bind(this));

        $('body').on('click', '#voucherRedeemBtn', function(e){            
            $('#voucherError').hide('fast');
            if($('#voucherCode').val().trim()){
                $('#voucherRedeemBtn').prop("disabled",true);
                $('#voucherCode').prop("disabled",true);
                                                
                $('#voucherRow').fadeTo('fast', 0.25, function(){
                    $.post($('#voucherRedeemBtn').data('ajaxUrl'), 
                    {
                        'voucherCode': $('#voucherCode').val(),
                        'reservationMail': $('#reservationMail').text(),
                        'reservationFromDate': $('#reservationStartDate').text(),
                        'reservationToDate': $('#reservationDepartureDate').text(),
                        'accommodationId': $('#accommodationId').text(),
                        'totalRent': ($('#rental-sum-included-total').text() !== '') ? parseFloat($('#rental-sum-included-total').text()) : parseFloat($('#rental-sum-total').text()),
                    },
                    function (data){
                        $('#voucherRow').fadeTo('fast', 1, function(){
                            if(data.error){
                                $('#voucherRedeemBtn').prop("disabled",false);
                                $('#voucherCode').prop("disabled",false);
                                $('#voucherError').show('fast');
                            }else{
                                $('.lastVoucherCode').val(data.code)
                                $('#voucherValidatedCode').text(data.code);
                                $('#voucherValidatedInfo').text(data.amountText);
                                $('#voucher').text(data.amount);
                                $('#voucher').data('type', data.type);
                                $('#voucher-total').data('totalDiscount', data.totalDiscount)
                                $('#voucherNoValid').hide('fast');
                                $('#voucherValid').show('fast');
                                
                                $('#voucher-container').addClass('col-8');
                                $('#voucher-total').addClass('col-4');
                                
                                this.calculateAll();
                            }
                        }.bind(this));
                        
                    }.bind(this),
                    'json');
                }.bind(this));
            }else{
                $('#voucherError').show('fast');
            }
        }.bind(this));

        if($('.lastVoucherCode').val().trim()){
           $('#voucherCode').val($('.lastVoucherCode').val().trim());
           $('#voucherRedeemBtn').click();
       }
    }
    getIntlLocale(locale) {
        switch (locale) {
            case 'nl':
                return 'nl-NL';
            break;
            case 'de': 
                return 'de-DE';
            break;
            case 'ru': 
                return 'ru-RU';
            break;
            case 'en':
                return 'en-US';
            break;
            case 'fr':
                return 'fr-FR';
            break;
            case 'es': 
                return 'es-ES';
            break;
            case 'no':
                return 'no-NO';
            break;
            case 'da':
                return 'da-DK';
            break;
            default:
                return 'en-US';
            break;
        }
    }
    getCookie(name) {
        let cookieArr = document.cookie.split(";");
        for(let i = 0; i < cookieArr.length; i++) {
            let cookiePair = cookieArr[i].split("=");
            if(name === cookiePair[0].trim()) {
                return decodeURIComponent(cookiePair[1]);
            }
        }
        return null;
    }
}

module.exports = AdditionalCosts;
